import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StayCurrentPortraitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stay_current_portrait"}/>
}
